import { PDFTitles } from 'core/enum/pdfTitles';

export const pdfOptions: PDFTitles[] = [
  PDFTitles.BASIC,
  PDFTitles.FULL,
  PDFTitles.GRAPHS
];
